const cx = require('classnames');

export function Panel({ children, className }) {
    return (
        <div className={cx("flex flex-col  p-4 bg-white rounded-[4px] shadow-[0px_0px_1px_#171a1f12,0px_0px_2px_#171a1f1f]", className)}>
            {children}
        </div>
    );
}